import { useCallback, useState } from 'react';

import {
  createRoute as apiCreate,
  deleteRoute as apiDelete,
} from '@/api/endpoints/routes';
import type { RouteRequest, RouteResponse } from '@/types/routes';

interface UseRouteMutationsValue {
  readonly saving: boolean;
  readonly create: (body: RouteRequest) => Promise<RouteResponse>;
  readonly remove: (routeId: string) => Promise<void>;
}

export function useRouteMutations(): UseRouteMutationsValue {
  const [saving, setSaving] = useState(false);

  const create = useCallback(async (body: RouteRequest) => {
    setSaving(true);
    try {
      return await apiCreate(body);
    } finally {
      setSaving(false);
    }
  }, []);

  const remove = useCallback(async (routeId: string) => {
    setSaving(true);
    try {
      await apiDelete(routeId);
    } finally {
      setSaving(false);
    }
  }, []);

  return { saving, create, remove };
}
